import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_3 = {
  key: 1,
  class: "row card1 w-full mt-4 relative h-full"
}
const _hoisted_4 = { class: "heightOfCard bg-white noScrollbar overflow-y-auto border-lightgrey border-l border-r border-b border-t rounded" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "h-full rounded relative flex justify-center cursor-pointer items-center"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "h-full bg-white border border-lightgrey rounded relative flex justify-center cursor-pointer items-center"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "text-base capitalize font-semibold text-black" }
const _hoisted_12 = {
  key: 2,
  class: "h-full bg-white border border-lightgrey rounded relative flex justify-center cursor-pointer items-center"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "text-base capitalize font-semibold text-black" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  class: "flex w-full bottom-5 right-0 bg-white rounded px-3 py-4 justify-end",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 2,
  class: "flex justify-center items-center w-full mt-8 bg-white h-10 border border-lightgrey rounded"
}
const _hoisted_19 = { class: "text-xs font-normal" }
const _hoisted_20 = {
  key: 3,
  class: "flex justify-center items-center w-full mt-8 bg-white h-10 border border-lightgrey rounded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_dots_loader = _resolveComponent("dots-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.thisScreen === 'rootScreen')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "row w-full mb-3 justify-between flex",
      style: {"align-items":"center"}
    }, [
      _createElementVNode("h1", { class: "title" }, "Frameworks")
    ], -1)),
    (_ctx.allControlSetFrameworks.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["noScrollbar overflow-y-auto", _ctx.thisScreen === 'rootScreen'?'heightOfCard2':'heightOfCard1'])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([_ctx.userInfo.currentRole === 10205 ? 'card-middle' : '', "flex flex-wrap pt-4 mb-10 noScrollbar overflow-y-auto"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allControlSetFrameworks, (obj) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "frameWorkCard ml-5 mb-5",
                    key: obj,
                    onClick: ($event: any) => (_ctx.changeBoxInput(obj._id, obj.controlFrameWork))
                  }, [
                    (Object.keys(obj).includes('controlImageUrl'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "cursor-pointer checkbox absolute top-3 left-3",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFrameWorks) = $event)),
                            value: obj._id
                          }, null, 8, _hoisted_7), [
                            [_vModelCheckbox, _ctx.selectedFrameWorks]
                          ]),
                          _createElementVNode("img", {
                            class: "imageFrame",
                            src: obj.controlImageUrl
                          }, null, 8, _hoisted_8)
                        ]))
                      : (obj.controlFrameWork == 'InternalControls')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "cursor-pointer checkbox absolute top-3 left-3",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFrameWorks) = $event)),
                              value: obj._id,
                              checked: "",
                              disabled: ""
                            }, null, 8, _hoisted_10), [
                              [_vModelCheckbox, _ctx.selectedFrameWorks]
                            ]),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(obj.controlFrameWork), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "cursor-pointer checkbox absolute top-3 left-3",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedFrameWorks) = $event)),
                              value: obj._id
                            }, null, 8, _hoisted_13), [
                              [_vModelCheckbox, _ctx.selectedFrameWorks]
                            ]),
                            _createElementVNode("p", _hoisted_14, _toDisplayString(obj.controlFrameWork), 1)
                          ]))
                  ], 8, _hoisted_5))
                }), 128))
              ], 2)
            ], 2),
            (_ctx.allControlSetFrameworks.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      class: _normalizeClass([_ctx.disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary', "mr-1.5"]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onCancelBtn()))
                    }, "Cancel", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(_ctx.disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary'),
                      disabled: _ctx.clickOnButton,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ApplyControls(_ctx.selectedFrameWorks)))
                    }, "Apply", 10, _hoisted_17)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_ctx.dataLoading == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, [
              _createVNode(_component_dots_loader)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[5] || (_cache[5] = [
            _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found", -1)
          ])))
  ]))
}